import { FilterBarFilterConfig, FilterValue } from './contracts';
import AutosuggestionFilterEditor from './editors/AutosuggestionFilterEditor';
import DateRangeFilterEditor from './editors/DateRangeFilterEditor';
import DropdownFilterEditor from './editors/DropdownFilterEditor';

interface FilterEditorPopoverProps {
  filter: FilterBarFilterConfig | null;
  value: FilterValue;
  onChange: (value: FilterValue) => void;
  onClose: () => void;
}

const FilterEditor = ({ filter, value, onChange, onClose }: Omit<FilterEditorPopoverProps, 'anchorEl'>) => {
  switch (filter?.type) {
    case 'dateRange':
      return (
        <DateRangeFilterEditor key={filter.id} filter={filter} value={value} onChange={onChange} onClose={onClose} />
      );
    case 'dropdown':
      return <DropdownFilterEditor filter={filter} value={value} onChange={onChange} onClose={onClose} />;
    case 'autosuggestion':
      return <AutosuggestionFilterEditor filter={filter} value={value} onChange={onChange} onClose={onClose} />;
    default:
      return null;
  }
};

export default FilterEditor;
